export enum CardType {
    VISA = "VISA",
    AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
    MASTERCARD = 'MASTERCARD',
    DINERS_CLUB = 'DINERS_CLUB'
}